(function() {
  'use strict';
  angular
    .module('eva2-angular')
    .component('evaBanner', {
      bindings: {
      },
      controllerAs: 'vm',
      template: require('./banner.html'),
      controller: function($rootScope) {  
        var vm = this;
        vm.closeBanner = function() {
          // set hasUserClosedBanner in the local storage to true to prevent the banner from showing again
          localStorage.setItem('hasUserClosedBanner', 'true');
          $rootScope.displayBanner = false;
        };
      }
    });
})();

